import { FuseUtils } from '@fuse/utils';
import { CwUtils } from './../../../../cw-utils/cw-utils.service';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { PageOptions } from '../../../util/backend-util-module';
import { AddressType } from '../../../models/backend-definitions.module';
import { ApiGateway } from '../../../api-gateway';

@Injectable()
export class AddressTypeListService implements Resolve<any>
{
    addressType: AddressType[];
    addressTypeEdit: AddressType;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    /**
     * Constructor
     *
     * @param {ApiGateway} gw
     */
    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.addressTypeEdit = this.state.currentAddressType;

        let currentPage = this.state.currentPage;
        if (currentPage) {
            this.pageOptions = currentPage;
            this.currentPage = currentPage;
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<AddressType> {
        if (!id) {
            return null;
        }
        return this.gw.get('addressType/:id', { id: id });
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('addressType/').subscribe((res: HttpResponse<any>) => {
                this.addressType = res.body;
                this.onDataChanged.next(this.addressType);
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('addressType/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.addressType, res.body.content)   && res.body.content.length > 0) {
                    this.addressType = res.body.content;
                    this.onDataChanged.next(this.addressType);
                } else {
                    this.addressType = res.body.content;
                }
                resolve(res);
            }, reject);
        });
    }
    
    getSimplePage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('addressType/simple/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.addressType, res.body.content)   && res.body.content.length > 0) {
                    this.addressType = res.body.content;
                    this.onDataChanged.next(this.addressType);
                } else {
                    this.addressType = res.body.content;
                }
                resolve(res);
            }, reject);
        });
    }

 
    getPageSettings() {
        return this.pageOptions;
    }


    get currentAddressType() {
        return this.addressTypeEdit;
    }
}

